import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'router'

import CardActionButton from 'components/global/CardActions/CardActionButton'

const ActionFake = ({ contact }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
      <CardActionButton
        sx={{
          border: '1px solid #E5E7EB',
          borderRadius: '8px',
          width: '32px',
          height: '32px'
        }}
        iconlabel={'masks-theater'}
        tooltiptitle={t('auth.simulating')}
        onClick={() => {
          navigate({
            pathname: '/auth/fake',
            search: {email: contact.email}
          })
        }}
      />
  )
}

export default ActionFake
